export const hasRestrictedPdpValidation = (product: { hasAgeRestriction?: boolean } | undefined): boolean => {
  return product?.hasAgeRestriction === true;
}